module.exports = __webpack_public_path__ + "static/media/navigation-arrow.5889e004.svg";